export enum BUTTONS {
    OKCANCEL = 1,
    SUBMITCANCEL,
    OK,
    YESNO
}   